import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QaiLinkButtonComponent } from '@qai/ui';

/**
 * Use this component to set standardized padding and max width on pages.
 */
@Component({
  imports: [CommonModule, QaiLinkButtonComponent],
  selector: 'details-section',
  standalone: true,
  styleUrls: ['./details-section.component.scss'],
  templateUrl: './details-section.component.html',
})
export class DetailsSectionComponent {
  @Input() title: string = '';
  @Input() subtitle?: string;
  @Input() description?: string | undefined = undefined;
  @Input() showDetails: boolean = false;
  @Input() detailsText: string = 'Clickable Action';
  @Input() actiondisabled? = false;

  @Output() readonly actionClicked = new EventEmitter();

  onActionClick(event: Event) {
    this.actionClicked.emit(event);
  }
}
